import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Autoplay} from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

const slider = document.querySelector('#home-slider')

if (slider) {
	new Swiper('.swiper.swiper-secteurs', {
		slidesPerView: 1.5,
		spaceBetween: 16,
		initialSlide: 2,
		centeredSlides: true,
		centeredSlidesBounds: true,
		centerInsufficientSlides: true,
		breakpoints: {
			420: {
				slidesPerView: 2,
				spaceBetween: 16
			},
			600: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			800: {
				slidesPerView: 3,
				spaceBetween: 30
			}
		},
		navigation: {
			prevEl: '.swiper-secteurs .swiper-prev',
			nextEl: '.swiper-secteurs .swiper-next'
		}
	});
}


const sliderHeader = document.querySelector('.slider-header')

if (sliderHeader) {

	new Swiper('.slider-header', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		loop: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 5000,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})
}




// WEBPACK FOOTER //
// ./scripts/frontPage.js